import React, {useState} from 'react';
import s from './styles.module.css';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import {Box, Button, Modal} from "@mui/material";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 4,
    borderRadius: '3px',
    maxWidth: '90%',
    width: '100%',
    maxHeight: '90vh',
    overflow: 'auto'
};

const ModalElement = ({open, onClose, data, setPage, confirm, isArtistik, status}) => {

    return (
        <Modal
            sx={{
                overflow: 'auto'
            }}
            open={open}
            // onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                {status === 'wait' ?
                    <h1 className={s.title}>Ожидайте перехода на следующую команду</h1> : <h1 className={s.title}>Подтвердите ввод оценок</h1>}

                <div className={s.content}>
                    {data?.map((el, i) => <div key={i} className={s.item}>
                        <div className={s.id}>{isArtistik ? el.artistic_type_id : +el.number}</div>
                        <div className={s.title_2}>{isArtistik ? el.artistic_type_name : el.part}</div>
                        <div className={s.value}>{el.value === null ? '' : Number(el.value).toFixed(2)}</div>
                    </div>)}
                </div>

                <div className={s.btns} style={{display: status === 'wait' ? 'none' : 'flex'}}>
                    <Button variant="outlined" color="error" onClick={onClose}>
                        <CloseIcon sx={{fontSize: 40}}/>
                    </Button>
                    <Button variant="contained" onClick={confirm} sx={{
                        marginLeft: '100px'
                    }}>
                        <CheckIcon sx={{fontSize: 40}}/>
                    </Button>
                </div>
            </Box>
        </Modal>
    );
};

export default ModalElement;
